const ITEMS = ["Interact", "Understand", "Protect Value", "AI Voice", "ChurnSense", "RetainAI", "WinBack"];

export const Marquee = () => {
  const row = (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-display text-6xl md:text-8xl tracking-tight whitespace-nowrap px-8 ${
              i % 2 === 0 ? "outline-text" : "outline-text-accent italic"
            }`}
          >
            {item}
          </span>
          <span className="text-vermilion text-2xl md:text-4xl">·</span>
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-line py-10 md:py-14 select-none">
      <div className="flex w-max animate-marquee">
        {row}
        {row}
      </div>
    </div>
  );
};
